<template>
  <div class="reward-records coming-soon">
    <page-header title="我的奖惩记录" style="margin-bottom: 20px;" />
    <ming-table :fields="column" :data="data" />
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { ref } from 'vue'
import { rewardRecordsColumn } from './tableColumn'

const column = ref(rewardRecordsColumn)
const data = ref([])

</script>
